import type { StepperProps } from 'fitify-ui-onboarding/src/components/GenderFunnel/Header/Stepper/Stepper.Types'
import { useRouter } from 'fitify-ui-onboarding/src/hooks/useRouter'
import {
  getPaging,
  PAGES_CACHE,
} from 'fitify-ui-onboarding/src/utils/navigation'
import { useCallback, useMemo } from 'react'

import { getHeaderStepper } from 'components/GenderFunnel/Layout/Layout.Utils'
import { useFunnel } from 'hooks/useFunnel'
import { useDataState } from 'utils/state'

export type UseLayoutNavigationProps = {
  hasNativeBackAction?: boolean
  hasRouterBackButton?: boolean
}

export const useLayout = ({
  hasNativeBackAction = false,
  hasRouterBackButton = true,
}: UseLayoutNavigationProps) => {
  const { isReady, resolvedPathname, replace, back } = useRouter()
  const funnel = useFunnel()
  const { data } = useDataState()

  const paging = useMemo(() => {
    const funnelData = funnel ? data[funnel] : {}

    return getPaging({
      path: resolvedPathname,
      data: funnelData,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, funnel, isReady, resolvedPathname])

  const handlePreviousClick = useCallback(() => {
    if (paging?.prev) {
      void replace(paging.prev.path)
    }
  }, [paging.prev, replace])

  const headerStepper = useMemo<StepperProps | undefined>(() => {
    const funnelData = funnel ? data[funnel] : {}

    return getHeaderStepper(PAGES_CACHE, paging.current, funnelData)
  }, [data, funnel, paging])

  return {
    handlePreviousClick:
      hasRouterBackButton && paging?.prev
        ? handlePreviousClick
        : hasNativeBackAction
          ? back
          : undefined,
    headerStepper,
  }
}
